import {
  SLOW_GESTURE_FRAME_COUNT,
  SLOW_GESTURE_FRAME_MS,
  SLOWNESS_OCCURRENCES_TO_REPORT,
} from '../config/slownessConfig';
import type { DiagramSlownessKind } from '../types/DiagramSlowness.types';

/** The gaps between the frames of a gesture that were long enough for the user to see the chart freeze. */
export function getGestureStutters(frameGaps: readonly number[]): number[] {
  return frameGaps.filter((gap) => gap >= SLOW_GESTURE_FRAME_MS);
}

export function isUnusableGesture(stutters: readonly number[]): boolean {
  return stutters.length >= SLOW_GESTURE_FRAME_COUNT;
}

/** True exactly once per kind: when its occurrences first reach the reporting count. */
export function isSlownessReportDue(kind: DiagramSlownessKind, occurrenceCount: number): boolean {
  return occurrenceCount === SLOWNESS_OCCURRENCES_TO_REPORT[kind];
}
